import Equalizer from "./Equalizer";

export default Equalizer;
